export default {
    
}

/**
 * Contains global configuration settings for the FileManager API
 */
export const GC_API = {
    /**
     * The root URL for all API calls
     */
    baseUrl: 'http://filemanager.naglotech.com/api/api/',
    /**
     * Headers needed for all API calls. Can be appended by using '...' syntax
     */
    baseHeaders: {
        'Content-Type': 'application/json'
    }
}

/**
 * Contains global configurations/methods for handling files
 */
export const GC_Files = {
    /**
     * Returns the fontawesome icon component array for the given file type
     * @param {String} fileType The files extension (without '.')
     */
    fileIcon(fileType) {
        let icon = 'file'
        switch (fileType) {
            case 'doc':
            case 'docx':
                icon = 'file-word'
                break
            case 'xls':
            case 'xlsx':
                icon = 'file-excel'
                break
            case 'pdf':
                icon = 'file-pdf'
                break
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'bmp':
            case 'gif':
            case 'tiff':
                icon = 'file-image'
                break
            default:
                icon = 'file'
        }
        return ['fad', icon]
    }
}


// WEBPACK FOOTER //
// ./src/config/global.js